module.exports = __webpack_public_path__ + "static/winner1-6bcfdc878c68b0627c8f287f347936c4.png";